import { useEffect, useRef } from "react";
import PageContainer from "@components/layout/PageContainer";
import { useNavigate } from "react-router-dom";
import { ModelIndexHandle } from "@components/layout/ModelIndex";
import { DebitnoteApi } from "@/api/DebitnoteApi";
import DebitnoteModelIndex from "@components/dynamic/modelIndexes/DebitnoteModelIndex";

const DebitnoteIndex = () => {
  const navigate = useNavigate();
  const modelRef = useRef<ModelIndexHandle>(null);

  useEffect(() => {
  }, []);

  return (
    <PageContainer
      title="Lista de Notas de Debito"
      backUrl="/user/dashboard-accounting"
      primaryActions={[
        {
          onClick: () => {
            navigate('/user/debitnotes/invoice-select')
          },
          actionTitle: "Nueva",
          color: "success"
        }
      ]}
      secondaryActions={[
        {
          actionTitle: "Cargar XML",
          href: "/user/debitnotes/import"
        }
      ]}
    >
      <DebitnoteModelIndex
        ref={modelRef}
        messages={{
          noResults: "No hay notas de debito creadas aun"
        }}
        fetchData={(...args) => DebitnoteApi.fetchAll(...args)}
      >
      </DebitnoteModelIndex>
    </PageContainer >
  );
}

export default DebitnoteIndex;
